import React, { Component } from 'react'
import ReactSearchBox from 'react-search-box'

const data = []
class SearchBox extends Component {
    constructor(props: Props) {
    super(props);

    this.state = {filter:'', 
                 data: [],
                  }
  }

  sendData = (record) => {

   const coords = record.target.getAttribute('coords').split(',')
   this.props.searchResult([coords[0], coords[1]]);
   this.setState({filter:''})
    
  }

  setData = (searchResult) => {
    this.setState({ data: searchResult });
  }

  handleChange = event => {
    this.setState({ filter: event.target.value });
  };

  componentDidMount() {
  
    //Build seach array
    var searchArray = []
    var clubs = this.props.clubs.features
    
    for (let item of clubs){
        const obj = {key: item.properties.uuid,
                    value: item.properties.name,
                    coords: item.geometry.coordinates
            } 
      searchArray.push(obj)
    }
    
    this.setData(searchArray)

  }


render() {

    const { filter, data } = this.state;
    const lowercasedFilter = filter.toLowerCase();
    
    const filteredData = data.filter(item => {

      return Object.keys(item).some(key =>

       item['value'].toString().toLowerCase().includes(lowercasedFilter)
      );
    });

    return (

       <div className="search-box" >
        <input className="search-box-input" value={filter} onChange={this.handleChange} placeholder="Suchen"/>
        <div className="search-result-wrapper"> 
           {filter !== '' &&
            <ul>
                      { filteredData.map(item => <li className="search-item" onClick={this.sendData.bind(item)} key={item.key} coords={item.coords}>{item.value} </li>)}
           </ul>


           } 
      </div>
      </div>
    )
  }
}

export default SearchBox